import { useEffect } from 'react';
import { useOptionalCatalogData } from '../CatalogData/CatalogDataProvider';

const fallbackName = 'INK-SU';
const fallbackSlogan = 'Insumos para tecnología';
const fallbackLogo = '/brand/inksu-logo-symbol.png';

export default function TitleMeta() {
    const catalogData = useOptionalCatalogData();
    const tiendaPrincipal = catalogData?.tiendaPrincipal;
    const ensureTienda = catalogData?.ensureTienda;

    useEffect(() => {
        if (ensureTienda) {
            ensureTienda().catch(() => {});
        }
    }, [ensureTienda]);

    useEffect(() => {
        const name = String(tiendaPrincipal?.nombre ?? '').trim() || fallbackName;
        const slogan = String(tiendaPrincipal?.eslogan ?? '').trim() || fallbackSlogan;
        const description = `${name} | ${slogan}`;

        document.title = description;

        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', description);
        } else {
            const meta = document.createElement('meta');
            meta.name = 'description';
            meta.content = description;
            document.head.appendChild(meta);
        }

        const linkIcon = document.querySelector("link[rel='icon']");
        if (linkIcon) {
            linkIcon.href = String(tiendaPrincipal?.imagen1 ?? '').trim() || fallbackLogo;
        } else {
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = String(tiendaPrincipal?.imagen1 ?? '').trim() || fallbackLogo;
            document.head.appendChild(link);
        }
    }, [tiendaPrincipal]);

    return null;
}
